"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectionHeader = void 0;
const crate_1 = require("@tcc/crate");
const react_1 = __importDefault(require("react"));
const SelectionHeader = ({ table: { getIsAllRowsSelected, getToggleAllRowsSelectedHandler, getIsSomeRowsSelected }, column }) => {
    const testId = `fds-table-selection-header-${column.id}`;
    return react_1.default.createElement(crate_1.Checkbox, { testId: testId, checked: getIsAllRowsSelected(), onChange: getToggleAllRowsSelectedHandler(), isIndeterminate: getIsSomeRowsSelected() });
};
exports.SelectionHeader = SelectionHeader;
